var f;
var g;
function h(u, v, w) {
  if (w >= this.val) {
    return -1;
  } else if (v[this.key] + w >= this.val) {
    return -2;
  } else if (this.multi) {
    return v[this.key] + w;
  } else {
    return -3;
  }
}
function j(u, v, w) {
  return (v ? v[this.key] : 0) + w;
}
var k = [
  {
    name: "Hitman",
    desc: "Get $ Kills",
    key: "kills",
    img: "icon_4",
  },
  {
    name: "Headhunter",
    desc: "Get $ Headshots",
    key: "headshots",
    img: "icon_2",
  },
  {
    name: "Assassin",
    desc: "Get $ Melee Kills",
    key: "melees",
    img: "icon_8",
  },
  {
    name: "Streakster",
    desc: "Get a $ Killstreak",
    key: "highestStreak",
    img: "icon_12",
  },
  {
    name: "Sidekick",
    desc: "Get $ Assists",
    key: "assists",
    img: "icon_10",
  },
  {
    name: "Trackstar",
    desc: "Capture $ flags",
    key: "caps",
    img: "icon_7",
  },
  {
    name: "Atomic",
    desc: "Call in $ Nukes",
    key: "nukes",
    img: "icon_0",
  },
  {
    name: "Competitive",
    desc: "Play $ Ranked matches",
    img: "icon_6",
    chck: function (u, v, w) {
      if (w >= this.val) {
        return -1;
      } else {
        if (u.mode.isRanked) {
          w++;
        }
        if (w >= this.val) {
          return -2;
        } else {
          return w;
        }
      }
    },
    prog: function (u, v, w) {
      return w;
    },
  },
  {
    name: "Casual",
    desc: "Play $ matches",
    img: "icon_6",
    chck: function (u, v, w) {
      if (w >= this.val) {
        return -1;
      } else if (++w >= this.val) {
        return -2;
      } else {
        return w;
      }
    },
    prog: function (u, v, w) {
      return w;
    },
  },
  {
    name: "High Flyer",
    desc: "Get $ Mid Air Kills",
    key: "airKills",
    img: "icon_3",
  },
  {
    name: "Trigger Happy",
    desc: "Get $ Quickscopes",
    key: "quickscopes",
    img: "icon_5",
  },
  {
    name: "Eyes Closed",
    desc: "Get $ Noscopes",
    key: "noscopes",
    img: "icon_11",
  },
  {
    name: "Full Metal Jacket",
    desc: "Get $ Wallbangs",
    key: "wallbangs",
    img: "icon_9",
  },
  {
    name: "Sharpshooter",
    desc: "Get $ Longshot Kills",
    key: "longshots",
    img: "icon_13",
  },
  {
    name: "Risk Taker",
    desc: "Get $ Close Call Kills",
    key: "closecalls",
    img: "icon_14",
  },
  {
    name: "Slip N Slide",
    desc: "Get $ Drift Kills",
    key: "driftkills",
    img: "icon_15",
  },
  {
    name: "BloodThirster",
    desc: "Get $ Firstblood",
    key: "firstblood",
    img: "icon_16",
  },
  {
    name: "Casual Winner",
    desc: "Win $ matches",
    img: "icon_6",
    chck: function (u, v, w) {
      if (w >= this.val) {
        return -1;
      } else {
        if (v.didWin) {
          w++;
        }
        if (w >= this.val) {
          return -2;
        } else {
          return w;
        }
      }
    },
    prog: function (u, v, w) {
      return w;
    },
  },
  {
    name: "Competitive Winner",
    desc: "Win $ Ranked matches",
    img: "icon_6",
    chck: function (u, v, w) {
      if (w >= this.val) {
        return -1;
      } else {
        if (u.mode.isRanked && v.didWin) {
          w++;
        }
        if (w >= this.val) {
          return -2;
        } else {
          return w;
        }
      }
    },
    prog: function (u, v, w) {
      return w;
    },
  },
  {
    name: "Juggernaut",
    desc: "Deal $ damage",
    key: "dmgDealt",
    img: "icon_19",
  },
  {
    name: "Arsenal",
    desc: "Get $ @ kills",
    key: "weaponKills",
    img: "icon_20",
    chck: function (u, v, w) {
      if (w >= this.val) {
        return -1;
      } else if ((v[this.key][this.wep] || 0) + w >= this.val) {
        return -2;
      } else if (this.multi) {
        return (v[this.key][this.wep] || 0) + w;
      } else {
        return -3;
      }
    },
    prog: function (u, v, w) {
      return ((v && v[this.key][this.wep]) || 0) + w;
    },
  },
  {
    name: "Arsenal Streakster",
    desc: "Get a $ @ Killstreak",
    key: "highestWeaponStreak",
    img: "icon_12",
    chck: function (u, v, w) {
      if (w >= this.val) {
        return -1;
      } else if ((v[this.key][this.wep] || 0) + w >= this.val) {
        return -2;
      } else if (this.multi) {
        return (v[this.key][this.wep] || 0) + w;
      } else {
        return -3;
      }
    },
    prog: function (u, v, w) {
      return ((v && v[this.key][this.wep]) || 0) + w;
    },
  },
  {
    name: "Beatdown",
    desc: "Get $ Fist Kills",
    key: "fistKills",
    img: "icon_22",
  },
  {
    name: "Bullseye",
    desc: "Get $ Thrown Melee Kills",
    key: "tKnifeKills",
    img: "icon_23",
  },
  {
    name: "Speed Demon",
    desc: "Get $ Turbo Kills",
    key: "turboKills",
    img: "icon_24",
  },
];
for (
  var m = [
      {
        list: [
          [1, 5, true],
          [3, 5],
          [9, 10, true],
        ],
        reward: {
          funds: 100,
        },
      },
      {
        list: [
          [10, 10, true],
          [1, 5],
          [2, 5, true],
          [17, 2, true],
        ],
        reward: {
          funds: 150,
        },
      },
      {
        list: [
          [3, 10],
          [19, 1000],
          [11, 10, true],
          [21, 5, false, 14],
        ],
        reward: {
          funds: 200,
        },
      },
      {
        list: [
          [2, 5],
          [10, 20, true],
          [4, 5],
        ],
        reward: {
          funds: 300,
        },
      },
      {
        list: [
          [20, 20, true, 13],
          [4, 20, true],
          [5, 5, true],
        ],
        reward: {
          funds: 400,
        },
      },
      {
        list: [
          [0, 100, true],
          [11, 5],
          [3, 15],
        ],
        reward: {
          funds: 500,
        },
      },
      {
        list: [
          [2, 10],
          [12, 3],
          [1, 50, true],
        ],
        reward: {
          funds: 600,
        },
      },
      {
        list: [
          [6, 1, true],
          [2, 100, true],
          [9, 25, true],
        ],
        reward: {
          funds: 700,
        },
      },
      {
        list: [
          [10, 15],
          [2, 15],
          [12, 25, true],
        ],
        reward: {
          funds: 800,
        },
      },
      {
        boss: true,
        list: [
          [0, 200, true],
          [2, 100, true],
          [6, 5, true],
          [11, 10],
        ],
        reward: {
          funds: 1500,
          lvlCol: "#fb942d",
        },
      },
      {
        list: [
          [15, 5],
          [14, 5],
          [5, 3],
        ],
        reward: {
          funds: 1600,
        },
      },
      {
        list: [
          [4, 5],
          [8, 20, true],
          [16, 10, true],
          [2, 10],
        ],
        reward: {
          funds: 1700,
        },
      },
      {
        list: [
          [13, 5],
          [10, 100, true],
          [11, 15],
        ],
        reward: {
          funds: 1800,
        },
      },
      {
        list: [
          [14, 30, true],
          [6, 1],
          [15, 50, true],
        ],
        reward: {
          funds: 1900,
        },
      },
      {
        boss: true,
        list: [
          [2, 15],
          [9, 20],
          [14, 10],
          [3, 30],
        ],
        reward: {
          funds: 2000,
          lvlCol: "#c12dfb",
        },
      },
      {
        list: [
          [6, 5, true],
          [0, 500, true],
        ],
        reward: {
          funds: 2100,
        },
      },
      {
        list: [
          [20, 20, false, 13],
          [20, 15, false, 2],
          [5, 30, true],
        ],
        reward: {
          funds: 2200,
        },
      },
      {
        list: [
          [3, 35],
          [20, 15, false, 15],
          [1, 300, true],
        ],
        reward: {
          funds: 2300,
        },
      },
      {
        list: [
          [12, 100, true],
          [2, 100, true],
          [15, 100, true],
        ],
        reward: {
          funds: 2400,
        },
      },
      {
        boss: true,
        list: [
          [6, 2],
          [2, 20],
          [17, 30, true],
          [1, 1000, true],
        ],
        reward: {
          funds: 3000,
          lvlCol: "#fb2d2d",
        },
      },
      {
        list: [
          [21, 20, false, 2],
          [21, 10, false, 12],
          [20, 200, true, 0],
          [1, 100, true],
        ],
        reward: {
          funds: 3100,
        },
      },
      {
        list: [
          [21, 15, false, 15],
          [21, 20, false, 12],
          [6, 5, true],
          [1, 500, true],
        ],
        reward: {
          funds: 3200,
        },
      },
      {
        list: [
          [18, 10, true],
          [5, 50, true],
          [2, 200, true],
          [16, 20, true],
        ],
        reward: {
          funds: 3300,
        },
      },
      {
        list: [
          [17, 50, true],
          [3, 55],
          [21, 20, false, 8],
          [10, 10],
        ],
        reward: {
          funds: 3400,
        },
      },
      {
        list: [
          [22, 10],
          [23, 1000, true],
          [3, 30],
        ],
        reward: {
          funds: 3500,
        },
      },
      {
        list: [
          [24, 250, true],
          [22, 20],
          [3, 55],
        ],
        reward: {
          funds: 3600,
        },
      },
    ],
    p = 0;
  p < m.length;
  p++
) {
  f = m[p].list;
  for (var q = 0; q < f.length; q++) {
    (g = {
      ...k[f[q][0]],
    }).val = f[q][1];
    g.wep = f[q][3];
    if (f[q][2]) {
      g.multi = true;
    }
    g.chck ||= h;
    g.prog ||= j;
    f[q] = g;
  }
}
module.exports = m;
